import { validateCPF } from './document';

export const validatePostalCode = (postalCode: string): boolean => {
  return new RegExp(/[0-9]{5}-[\d]{3}/).test(postalCode) || new RegExp(/[0-9]{8}/).test(postalCode);
};

export const validateEmail = (email: string): boolean => {
  return new RegExp(/^\w+([/+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(email);
};

export const validateUsername = (username: any): boolean => {
  return validateEmail(username) || validateCPF(username);
};

export const validatePassword = (password: any): boolean => {
  return password.lenght >= 6;
};

export const validatePhoneNumber = (phone: String): boolean => {
  phone = phone.replace(/\D/g, '');

  const numberWithoutPrefixes = [...phone.substr(3, phone.length)];

  if (phone.length !== 11) {
    return false;
  }

  if (numberWithoutPrefixes.every(number => number === numberWithoutPrefixes[0])) {
    return false;
  }

  return phone[2] === '9';
};

export const validateBirthDate = (birthday: any): boolean => {
  const date = new Date(birthday);

  const year = date.getFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();

  return new Date(year + 18, month, day) <= new Date();
};
